module.exports = __webpack_public_path__ + "static/media/piece-09.0e68a0b1.png";